import { render, staticRenderFns } from "./ResumeManagementCard.vue?vue&type=template&id=44356f38&"
import script from "./ResumeManagementCard.vue?vue&type=script&lang=js&"
export * from "./ResumeManagementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports